import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { RxFillAlertsCount } from "../../Apis/AuthApiServices";
import {
  loadingRxFillAlertsCount,
  setRxFillAlertsCount,
} from "../Slice/RxFillAlertsCountSlice";

function* onLoadRxFillAlertsCountAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageSize", payload.pageSize);
  params.append("pageNumber", payload.pageNumber);
  try {
    const result: AxiosResponse = yield RxFillAlertsCount(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setRxFillAlertsCount({
          RxFillAlertsCountData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setRxFillAlertsCount({
          RxFillAlertsCountData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setRxFillAlertsCount({
        RxFillAlertsCountData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadRxFillAlertsCount() {
  yield takeLatest(loadingRxFillAlertsCount.type, onLoadRxFillAlertsCountAsync);
}

const RxFillAlertsCountSaga = [fork(onLoadRxFillAlertsCount)];
export default RxFillAlertsCountSaga;
